// TODO (@core): Consider renaming this folder to `device`

export const DEVICE_TYPES = ['mobile', 'tablet', 'desktop'] as const

export type DeviceCategory = (typeof DEVICE_TYPES)[number]
